<template>
    <div class="quickpay-faq">
        <div class="quickpay-faq__header">
            <CompassColoredIcon icon="help-circle" :color="CompassEnums.ColoredIconColorType.LIGHT_BLUE" />
            <span class="typographies-paragraph-large-semibold">
                {{ translations.faqTitle }}
            </span>
        </div>
        <CompassAccordion
            v-for="(item, index) in translatedItems"
            :key="index"
            class="quickpay-faq__accordion"
            :title="item.question"
            :variant="CompassEnums.AccordionVariantType.H4"
        >
            <p class="quickpay-faq__answer typographies-paragraph-medium-regular">
                <template v-for="(part, partIndex) in item.answerParts" :key="partIndex">
                    <br v-if="part.type === 'br'" />
                    <CompassLink
                        v-else-if="part.type === 'link'"
                        :label="part.label"
                        :link="part.url"
                        target="_blank"
                    />
                    <span v-else>{{ part.content }}</span>
                </template>
            </p>
        </CompassAccordion>
    </div>
</template>

<script setup lang="ts">
import { computed, inject } from 'vue';
import { Translator } from 'js/shims-vue';
import { type TranslationPart, useTranslationLinkParser } from 'composables/useTranslationLinkParser';

interface FaqItem {
    questionKey: string;
    answerKey: string;
}

interface Props {
    items: FaqItem[];
}

const props = defineProps<Props>();

const $t = inject('$t') as Translator;

const { parseTranslation } = useTranslationLinkParser();

const translations = {
    faqTitle: $t.__('quickpay.settings.setupModal.common.faqTitle'),
};

const translatedItems = computed((): { question: string; answerParts: TranslationPart[] }[] =>
    props.items.map((item) => ({
        question: $t.__(item.questionKey),
        answerParts: parseTranslation($t.__(item.answerKey)),
    })),
);
</script>

<style lang="scss" scoped>
.quickpay-faq {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-2);
    &__header {
        display: flex;
        align-items: center;
        gap: var(--spacing-1);
        color: var(--colors-common-text-standard-default);
    }
    &__accordion {
        padding: 0 var(--spacing-5);
    }
    &__answer {
        margin: 0;
        color: var(--colors-common-text-subtle-default);
    }
}
</style>
